export default "__VITE_ASSET__Bsr9IBRg__"